import {Component, effect, inject, signal, Signal} from '@angular/core';
import {SharedModule} from '../../../../core/modules/shared.module';
import {MaterialModule} from '../../../../core/modules/material.module';
import {PagesContainerComponent} from '../../pages-container/pages-container.component';
import {OrganizationsService} from '../../../../core/services/organizations.service';
import {Subscription} from 'rxjs';
import {FuseConfigService} from '../../../../core/services/config.service';

@Component({
  selector: 'org-competency',
  templateUrl: './org-competency.component.html',
  styleUrls: ['./org-competency.component.scss'],
  imports: [SharedModule, MaterialModule, PagesContainerComponent]
})

export class OrgCompetencyComponent {
  private orgService = inject(OrganizationsService);
  private fuseConfigService = inject(FuseConfigService);
  public subscription = new Subscription();

  public organizationId = this.fuseConfigService.organizationId_Sig;
  public competencies = signal<any[]>([]);

  constructor() {
    effect((onCleanup) => {
      let orgId = this.organizationId();
      if (orgId) {
        if (!orgId) {
          this.competencies.set([]);
          return;
        }
        const subscription = this.orgService.getCompetenciesByOrganizationId(orgId)
          .subscribe((data: any) => {
            this.competencies.set(data);
          });
        onCleanup(() => subscription.unsubscribe());
      }
    });
  }

  toggleCompetency(competency: any) {
    const newStatus = !competency.enabled;
    this.competencies.update(current =>
      current.map(c => c.id === competency.id ? { ...c, enabled: !c.enabled } : c)
    );
    this.orgService.updateCompetencyStatus(competency.id, newStatus).subscribe();
  }
}
